import React from 'react'

import {Layout, Menu} from 'antd';
import {URL, URL_CRM} from "../constants/ApiConfig";

const {Header} = Layout;

const HeaderTop = () => (
    <Header className="header">
        <div className="logo"/>
        <Menu theme="dark" mode="horizontal" >
            <Menu.Item key="1">
                <a href="https://{URL}" target="_blank" rel="noopener noreferrer">
                    SITE
                </a>
            </Menu.Item>
            <Menu.Item key="2">
                <a href="{URL_CRM}" target="_blank" rel="noopener noreferrer">
                    CRM
                </a>
            </Menu.Item>
            <Menu.Item key="2">
                <a href="https://{URL}/blog" target="_blank" rel="noopener noreferrer">
                    BLOG
                </a>
            </Menu.Item>
        </Menu>
    </Header>

)

export default HeaderTop
